export type FilterTemplateType = "text" | "number" | "boolean" | "date" | "select";

export type FilterTemplate = {
  type: FilterTemplateType;
  values?: string[];
};

const datasetTemplates: Record<string, Record<string, FilterTemplate>> = {
  "identity:users:v4": {
    status: {type: "select", values: ["active", "inactive", "blocked", "deleted"]},
  },
  "personal_data:verification": {
    verificationStatus: {type: "select", values: ["pending", "verified", "rejected"]},
    verificationKind: {type: "select", values: ["identity", "residence"]},
  },
  "logs:administration": {
    level: {type: "select", values: ["DEBUG", "INFO", "WARNING", "ERROR", "CRITICAL"]},
  },
  "logs:identity": {
    level: {type: "select", values: ["DEBUG", "INFO", "WARNING", "ERROR", "CRITICAL"]},
  },
  "logs:personal_data": {
    level: {type: "select", values: ["DEBUG", "INFO", "WARNING", "ERROR", "CRITICAL"]},
  },
  "logs:dictionary": {
    level: {type: "select", values: ["DEBUG", "INFO", "WARNING", "ERROR", "CRITICAL"]},
  },
};

const booleanFields = new Set([
  "active", "disabled", "enabled", "system", "verified", "ready",
  "emailVerified", "phoneVerified", "isActive", "isDeleted", "isVerified",
]);

const numberFields = new Set([
  "statusCode", "sessionDuration", "restarts", "replicas", "available",
  "updated", "ageSeconds", "cpuMillicores", "memoryMiB",
]);

// Date fields are frequently camel-cased as datetimeVerified or eventTime.
// This remains a type hint only: values are never collected from response rows.
const dateFieldPattern = /(?:date|time|timestamp)/i;

export const tableFilterTemplate = (datasetKey: string, field: string): FilterTemplate => {
  const configured = datasetTemplates[datasetKey]?.[field];
  if (configured) return configured;
  const leaf = field.split(".").pop() || field;
  if (booleanFields.has(leaf)) return {type: "boolean"};
  if (numberFields.has(leaf)) return {type: "number"};
  if (dateFieldPattern.test(leaf) || /At$/.test(leaf)) return {type: "date"};
  return {type: "text"};
};
